import { NgModule } from '@angular/core';
import { SanitizeHtmlPipe, SearchPipe, OrderByPipe ,SafePipe} from './pipes/filter.pipe';
import { OverviewPipe } from './pipes/overview.pipe';
import { TranslatePipe } from './pipes/translate.pipe';
import { TextFilterPipe, KeyFilterPipe } from './key-filter.pipe';
// import { ToastrModule } from 'ngx-toastr';
// import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

@NgModule({
  imports: [
    // BrowserAnimationsModule,
    // ToastrModule.forRoot({
    //   timeOut: 10000,
    //   positionClass: 'toast-bottom-right', closeButton: true, toastClass: 'toaster-bar', tapToDismiss: true, messageClass: 'toaster-message', progressBar: true
    // })
  ],
  declarations: [
    SanitizeHtmlPipe,
    OrderByPipe,
    SearchPipe,
    OverviewPipe,
    TranslatePipe,
    TextFilterPipe,
    KeyFilterPipe,
    SafePipe
  ],

  exports: [
    SanitizeHtmlPipe,
    OrderByPipe,
    SearchPipe,
    OverviewPipe,
    TranslatePipe,
    TextFilterPipe,
    KeyFilterPipe,
    SafePipe
  ]
})
export class SharedModule { }
